"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconAddCategory = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M59.35 23.95H44.56a2 2 0 0 1-1.18-.39 14.08 14.08 0 0 0-16.76 0 2 2 0 0 1-1.18.39H10.65a5.27 5.27 0 0 1-5.26-5.26v-6.76a5.27 5.27 0 0 1 5.26-5.26h48.7a5.27 5.27 0 0 1 5.26 5.26v6.76a5.27 5.27 0 0 1-5.26 5.26zm-14.15-4h14.15a1.26 1.26 0 0 0 1.26-1.26v-6.76a1.26 1.26 0 0 0-1.26-1.26h-48.7a1.26 1.26 0 0 0-1.26 1.26v6.76a1.26 1.26 0 0 0 1.26 1.26H24.8a18.07 18.07 0 0 1 20.4 0zM20.24 43.64h-9.59a5.27 5.27 0 0 1-5.26-5.26v-6.76a5.27 5.27 0 0 1 5.26-5.26h9.58a2 2 0 0 1 1.82 2.82 14 14 0 0 0 0 11.64 2 2 0 0 1-1.82 2.82zm-9.59-13.28a1.26 1.26 0 0 0-1.26 1.26v6.76a1.26 1.26 0 0 0 1.26 1.26h6.75a18 18 0 0 1 0-9.28zM59.35 43.64h-9.59a2 2 0 0 1-1.82-2.82 14 14 0 0 0 0-11.64 2 2 0 0 1 1.82-2.82h9.58a5.27 5.27 0 0 1 5.26 5.26v6.76a5.27 5.27 0 0 1-5.25 5.26zm-6.75-4h6.75a1.26 1.26 0 0 0 1.26-1.26v-6.76a1.26 1.26 0 0 0-1.26-1.26H52.6a18 18 0 0 1 0 9.28zM59.35 63.33h-48.7a5.27 5.27 0 0 1-5.26-5.26v-6.76a5.27 5.27 0 0 1 5.26-5.26h14.79a2 2 0 0 1 1.18.39 14.08 14.08 0 0 0 16.75 0 2 2 0 0 1 1.18-.39h14.8a5.27 5.27 0 0 1 5.26 5.26v6.76a5.27 5.27 0 0 1-5.26 5.26zm-48.7-13.28a1.26 1.26 0 0 0-1.26 1.26v6.76a1.26 1.26 0 0 0 1.26 1.26h48.7a1.26 1.26 0 0 0 1.26-1.26v-6.76a1.26 1.26 0 0 0-1.26-1.26H45.2a18.07 18.07 0 0 1-20.39 0zM43.37 33.29a1.71 1.71 0 1 1 0 3.42h-6.66v6.66a1.71 1.71 0 0 1-3.42 0v-6.66h-6.66a1.71 1.71 0 1 1 0-3.42h6.66v-6.66a1.71 1.71 0 1 1 3.42 0v6.66z"
  })),
  height: undefined,
  width: undefined
});
IconAddCategory.displayName = 'IconAddCategory';
var _default = IconAddCategory;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/add-category.js
// module id = 544
// module chunks = 0